import { render, staticRenderFns } from "./compareMotor.vue?vue&type=template&id=14534f69&"
import script from "./compareMotor.vue?vue&type=script&lang=ts&"
export * from "./compareMotor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports